import React, { useEffect, useState } from 'react';
import { Box, Button, Tabs, Tab, Grid, Paper, Alert, Card, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import { CommonModal } from '../../../shared';
import TrainingFilter from './TrainingFilter';
import { styled } from '@mui/material/styles';
import { TrainingList, Summary } from './Index';
import dummyDataList from './TraininglistDummyData.json';
import { StencilList } from "react-placemoulder";
import { useDispatch, useSelector } from 'react-redux';
import { training_list } from '../../../redux/actions/training.action';
import "./Training.css"
import { CustomizedSnackbar, ConfirmationModal } from '../../../shared/index';
import InfiniteScroll from "react-infinite-scroller";
import AttendeesModal from './AttendeesModal';
import CommentModal from './CommentModal';
import { SnackbarActions } from '../../../redux/actions/snackbar.actions';
import { axiosFetch } from "../../../utils/AxiosFetch";
import PropTypes from 'prop-types';
import AllExternalTraining from './AllExternalTraining';



const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    color: theme.palette.text.secondary,
    borderRadius: 10
}));


function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

function TrainingHome() {
    var isUserLogged = localStorage.getItem('argus_user') !== null ? JSON.parse(localStorage.getItem('argus_user')) : "";
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [value, setValue] = React.useState(0);
    const [open, setOpen] = useState(false);
    const [trainingList, setTrainingList] = useState(dummyDataList);
    const [loading, setLoading] = useState(true);
    const [pageNo, setPageNo] = useState(1);
    const [resultsPerPage, setResultsPerPage] = useState(6);
    const [title, setTitle] = useState("");
    const [level, setLevel] = useState("");
    const [emp, setEmp] = useState(0);
    const [date, setDate] = useState("");
    const [year, setYear] = useState("");
    const [empLevel, setEmpLevel] = useState("");
    const [statusId, setStatusId] = useState(0);
    const [pagination, setPagination] = useState({});
    const [scrolling, setScrolling] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [statusName, setStatusName] = useState("");
    const [trainingId, setTrainId] = useState(0);
    const [orderby, setOrderBy] = useState("StatusId");
    const [orderByDirection, setOrderByDirect] = useState("asc");
    const [summary, setSummary] = useState({});
    const [attendeesOpen, setAttendeesOpen] = useState(false);
    const [trainingType, setTrainingType] = useState("");
    const [id, setId] = useState(0);
    const [commentModal, setcommentModal] = useState(false);
    const [rejectComment, setRejectComment] = useState("");
    const [trainingStatus, setTrainingStatus] = useState("");
    const [trainingTitle, setTrainingTitle] = useState("");
    const [trainingStartDate, setTrainingStartDate] = useState("");
    const [openConfirm, setOpenConfirm] = useState(false);
    const [content, setContent] = useState("");
    const [TabValue, setTabValue] = useState(0);


    let trainingListReducer = useSelector(state => state.fetchTrainingList_Reducer.trainingList)

    useEffect(() => {
        var req = {
            "page": pageNo,
            "resultsPerPage": resultsPerPage,
            "title": title,
            "year": year,
            "trainingLevelId": level,
            "employeeLevelId": empLevel,
            "dateFilter": date,
            "statusId": statusId,
            "employeeId": emp,
            "orderBy": orderby,
            "orderByDirection": orderByDirection,
        }
        fetchTrainingList(req)
    }, [])

    useEffect(() => {
        if (trainingListReducer !== undefined) {
            if (trainingListReducer.pagination !== undefined) {
                setPagination(trainingListReducer.pagination)
                setPageNo(trainingListReducer.pagination.page)
            }
            if (trainingList && trainingList.length > 0 && trainingListReducer.pagination && trainingListReducer.pagination.page > 1) {
                var list = [...trainingList, ...trainingListReducer.trainings];
                setTrainingList(list)
                setScrolling(false);
                if (trainingListReducer.pagination !== undefined) {
                    setPagination(trainingListReducer.pagination)
                    setPageNo(trainingListReducer.pagination.page)
                }
            }
            else {
                setLoading(false)
                setTrainingList(trainingListReducer.trainings)
                setSummary(trainingListReducer.summary)
                if (trainingListReducer.pagination !== undefined) {
                    setPagination(trainingListReducer.pagination)
                    setPageNo(trainingListReducer.pagination.page)
                }
            }

        }

    }, [trainingListReducer])

    const fetchTrainingList = (req) => {
        dispatch(training_list(req))
    };
    const onSearch = (req) => {
        setLoading(true)
        dispatch(training_list(req))
    }
    const handlePagination = () => {
        if (pageNo + 1 <= pagination.totalPages) {
            setPageNo(pageNo + 1)
            var req = {
                "page": pageNo + 1,
                "resultsPerPage": resultsPerPage,
                "title": title,
                "year": year,
                "trainingLevelId": level,
                "employeeLevelId": empLevel,
                "dateFilter": date,
                "statusId": statusId,
                "employeeId": emp,
                "orderBy": orderby,
                "orderByDirection": orderByDirection,
            }
            fetchTrainingList(req)
            setScrolling(true)
        }
    }
    const handlePopup = () => {
        if (open) {
            setOpen(false)
            setIsEdit(false)
        }
        else {
            setOpen(true)
        }
    }
    const handleTitleFilter = (value) => {
        setTitle(value)
    }
    const handleLevelFilter = (id) => {
        setLevel(id)
    }
    const handleEmployeeFilter = (id) => {
        setEmp(id)
    }
    const handlePeriodFilter = (date, year) => {
        setDate(date);
        setYear(year);
    }
    const handleStatusFilter = (id) => {
        setStatusId(id)
    }
    const handleEmpLevelFilter = (id) => {
        setEmpLevel(id)
    }
    // const handleOrderBy = (value) => {
    //     setOrderBy(value)
    //     var req = {
    //         "page": 1,
    //         "resultsPerPage": resultsPerPage,
    //         "title": title,
    //         "year": year,
    //         "levelId": level,
    //         "dateFilter": date,
    //         "statusId": statusId,
    //         "employeeId": emp,
    //         "orderBy": value,
    //         "orderByDirection": orderByDirection,
    //     }
    //     setLoading(true)
    //     fetchTrainingList(req)
    // }
    const handleEditControl = () => {
        if (isEdit) {
            setIsEdit(false)
        }
        else {
            setIsEdit(true)
        }
    }
    const handleTraining = (id, name) => {
        setTrainId(id);
        setStatusName(name);
    }
    const handleSort = (order, sort) => {
        setOrderBy(order)
        setOrderByDirect(sort)
        var req = {
            "page": 1,
            "resultsPerPage": resultsPerPage,
            "title": title,
            "year": year,
            "trainingLevelId": level,
            "employeeLevelId": empLevel,
            "dateFilter": date,
            "statusId": statusId,
            "employeeId": emp,
            "orderBy": order,
            "orderByDirection": sort,
        }
        setLoading(true)
        fetchTrainingList(req)
    }
    const handleAttendeesModal = (id, type, status, title, startDate) => {
        if (attendeesOpen) {
            setId(0)
            setTrainingType("")
            setAttendeesOpen(false)
            setTrainingStatus("")
        }
        else {
            setId(id);
            setTrainingType(type);
            setAttendeesOpen(true);
            setTrainingStatus(status);
            setTrainingTitle(title);
            setTrainingStartDate(startDate);
        }
    }
    const handleComment = (val) => {
        if (commentModal) {
            setcommentModal(false)
        }
        else {
            setRejectComment(val);
            setcommentModal(true)
        }
    }
    const handleConfirmationPopup = (id, type, name) => {
        if (openConfirm) {
            setOpenConfirm(false)
            setTrainId(0)
        }
        else {
            setTrainId(id)
            setContent(`Are you sure you want to delete "${name}" training ?`)
            setOpenConfirm(true)
        }
    }
    const deleteTraining = () => {
        axiosFetch({
            url: `/Training/${trainingId}`,
            method: "delete",
        })
            .then((res) => {
                if (res.status === 200) {
                    var req = {
                        "page": 1,
                        "resultsPerPage": 6,
                        "title": "",
                        "year": "",
                    }
                    dispatch(SnackbarActions(true, "success", `Deleted Successfully `))
                    setOpenConfirm(false)
                    dispatch(training_list(req))
                }
                if (res.status === 400) {
                    dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
                }
                if (res.status === 401) {
                    navigate("/");
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    const handleChange = (event, newValue) => {
        setTabValue(newValue);

    };
    return (
        <Box sx={{ width: '100%' }}>
            {isUserLogged.usertype === "TrainingManager"?
            <Box sx={{ borderBottom: 1, borderColor: 'divider', marginTop: "15px", borderColor: "#113776" }}>
                <Tabs className='training-tab' value={TabValue} onChange={handleChange} aria-label="basic tabs example">
                    <Tab className='one-tab' label="Internal Training" {...a11yProps(0)} />
                    <Tab className='sec-tab' label="External Training" {...a11yProps(1)} />
                </Tabs>
            </Box>:""}
            <TabPanel value={TabValue} index={0}>
                <div className='org-training'>
                    <h1 className="main-heading" style={{ marginBottom: -45 }}>Training List</h1>
                    {isUserLogged.usertype === "TrainingManager" || isUserLogged.usertype === "Admin" ? <Button variant="contained" className="theme-btn m-top" onClick={() => setOpen(true)}>Add New Training</Button> : ""}
                    <Grid container spacing={2}>
                        <Grid item xs={12}>                           
                            <>{summary !== undefined && summary !== null ?
                                <Summary count={pagination.totalRecords} summary={summary} handleArrow={handleSort} /> : ""
                            }
                            </>
                            {/* }  */}
                        </Grid>
                        <Grid item xs={3}>
                            <TrainingFilter
                                searchTitle={handleTitleFilter}
                                serachLevel={handleLevelFilter}
                                searchEmployee={handleEmployeeFilter}
                                searchPeriod={handlePeriodFilter}
                                searchStatus={handleStatusFilter}
                                searchEmpLevel={handleEmpLevelFilter}
                                // sortBy = {handleOrderBy}
                                onFilter={onSearch}
                            />
                        </Grid>

                        <Grid item xs={9}>
                            {loading ?
                                <StencilList
                                    length={5}
                                    Component={TrainingList}
                                    data={trainingList}
                                /> :
                                <InfiniteScroll
                                    // dataLength={trainingList.length}
                                    initialLoad={false}
                                    loadMore={scrolling === false ? handlePagination : ""}
                                    hasMore={pageNo <= pagination.totalPages}
                                    threshold={500}
                                >
                                    {/* {trainingList && trainingList.length > 0?(orderByDirection === "asc"?<ArrowUpwardIcon fontSize='small' onClick={()=>handleSort("desc")}/>:<ArrowDownwardIcon onClick={()=>handleSort("asc")}/>):""} */}
                                    {trainingList &&
                                        trainingList.length > 0 ?
                                        trainingList.map((trainingList) => {
                                            return (

                                                <TrainingList {...trainingList}
                                                    key={trainingList.titleId}
                                                    from="trainingHome"
                                                    setTrainingId={handleTraining}
                                                    handleEdit={handleEditControl}
                                                    handleEditModal={handlePopup}
                                                    handleAttendees={handleAttendeesModal}
                                                    handleCommentModal={handleComment}
                                                    handleConfirmation={handleConfirmationPopup}

                                                    work="view"
                                                />
                                            )
                                        }) :
                                        <Alert severity="error">No Trainings Found</Alert>
                                    }
                                </InfiniteScroll>
                            }
                        </Grid>
                    </Grid>
                    <CommonModal module="addnewTraining" openModal={open} handlepopupState={handlePopup} isTrainingEdit={isEdit} editId={trainingId} TrainingStatus={statusName} />
                    <CustomizedSnackbar />
                    <AttendeesModal open={attendeesOpen} handleAttendees={handleAttendeesModal} id={id} type={trainingType} status={trainingStatus} trainingTitle={trainingTitle} trainingStartDate={trainingStartDate} />
                    <CommentModal open={commentModal} handleCommentModal={handleComment} comment={rejectComment} />
                    <ConfirmationModal open={openConfirm} handleClose={handleConfirmationPopup} message={content} handleYes={deleteTraining} />
                </div>
            </TabPanel>
            <TabPanel value={TabValue} index={1}>
                <AllExternalTraining />
            </TabPanel>
        </Box>

    )
}
export default TrainingHome;